import { BaseError } from "./BaseError";
/**
 * InitializationError
 */ export class InitializationError extends BaseError {
    constructor(name, message){
        super();
        this.name = "InitializationError";
        this.message = `${name}${message ? ". " + message : ""}`;
    }
}
